export let surveyPoint = null;
export let graphicsLayer = null;
export let surveyVisibleBoolean = false;